import Box from '@mui/material/Box';

import { useStyles } from './DashboardPage.styles';

export const DashboardPage = () => {
    const { classes } = useStyles();

    return (
        <Box className={classes.root} automation-id="dashboard-page">
            <Box className={classes.content} />
        </Box>
    );
};
